import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logoImg from '../../logo.png';

const DEMO = [
  { label: 'Admin',  email: 'admin@ucelites.com',   role: 'Full access' },
  { label: 'Coach',  email: 'rivera@ucelites.com',  role: 'Team management' },
  { label: 'Parent', email: 'parent1@gmail.com',    role: 'Player view' },
];

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    setTimeout(() => {
      const r = login(email, password);
      if (r.ok) navigate('/dashboard');
      else setError('Invalid credentials. Use a demo account below.');
      setLoading(false);
    }, 400);
  };

  const demoLogin = (demoEmail) => {
    setLoading(true);
    setTimeout(() => {
      const r = login(demoEmail, 'demo');
      if (r.ok) navigate('/dashboard');
      setLoading(false);
    }, 250);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'radial-gradient(circle at 50% 20%, rgba(199,163,93,0.12) 0%, transparent 28%), linear-gradient(180deg, #020202 0%, #090909 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', position: 'relative', overflow: 'hidden' }}>
      {/* Subtle background pattern */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 50% 30%, rgba(199,163,93,0.08) 0%, transparent 58%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 420, position: 'relative', zIndex: 1 }}>
        {/* Dark card */}
        <div style={{ background: 'rgba(10,10,10,0.96)', borderRadius: 16, padding: '2rem', boxShadow: '0 24px 72px rgba(0,0,0,0.55), 0 0 0 1px rgba(199,163,93,0.22)', position: 'relative', overflow: 'hidden', backdropFilter: 'blur(14px)' }}>
          {/* Gold top border */}
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, #A87820, #D4A520, #C8962A, #A87820)' }} />

          {/* Logo inside card */}
          <div style={{ textAlign: 'center', marginBottom: '1.5rem', paddingTop: '0.5rem' }}>
            <img src={logoImg} alt="UC Elites" style={{ width: 140, height: 140, objectFit: 'contain' }} />
            <div style={{ color: 'rgba(200,150,42,0.7)', fontSize: 9, letterSpacing: '0.25em', textTransform: 'uppercase', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, marginTop: 8 }}>CLUB MANAGEMENT PORTAL</div>
          </div>

          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#D4A520', marginBottom: '1.5rem', fontFamily: "'Barlow Condensed', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em' }}>Sign in</h2>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#aaaaaa', textTransform: 'uppercase', letterSpacing: '0.07em' }}>Email address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required
                style={{ padding: '9px 12px', border: '1px solid rgba(199,163,93,0.25)', borderRadius: 6, fontSize: 14, color: '#ffffff', background: 'rgba(255,255,255,0.04)', outline: 'none', transition: 'border-color 0.15s' }}
                onFocus={e => e.target.style.borderColor = '#C8962A'}
                onBlur={e => e.target.style.borderColor = 'rgba(199,163,93,0.25)'} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#aaaaaa', textTransform: 'uppercase', letterSpacing: '0.07em' }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                style={{ padding: '9px 12px', border: '1px solid rgba(199,163,93,0.25)', borderRadius: 6, fontSize: 14, color: '#ffffff', background: 'rgba(255,255,255,0.04)', outline: 'none', transition: 'border-color 0.15s' }}
                onFocus={e => e.target.style.borderColor = '#C8962A'}
                onBlur={e => e.target.style.borderColor = 'rgba(199,163,93,0.25)'} />
            </div>
            {error && <p style={{ color: '#e07070', fontSize: 13, padding: '8px 12px', background: 'rgba(160,30,30,0.2)', borderRadius: 8, border: '1px solid rgba(224,112,112,0.35)' }}>{error}</p>}
            <button type="submit" disabled={loading}
              style={{ background: 'linear-gradient(135deg, #A87820, #D4A520, #C8962A)', backgroundSize: '200% auto', color: '#000000', border: 'none', padding: '11px', borderRadius: 8, fontSize: 14, fontWeight: 800, cursor: 'pointer', marginTop: 4, fontFamily: "'Barlow', sans-serif", letterSpacing: '0.06em', textTransform: 'uppercase', boxShadow: '0 2px 14px rgba(200,150,42,0.4)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.backgroundPosition = 'right center'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(200,150,42,0.6)'; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundPosition = 'left center'; e.currentTarget.style.boxShadow = '0 2px 14px rgba(200,150,42,0.4)'; }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          {/* Demo accounts */}
          <div style={{ marginTop: '1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <div style={{ flex: 1, height: 1, background: 'rgba(200,150,42,0.25)' }} />
              <span style={{ fontSize: 10, color: '#888888', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Demo accounts</span>
              <div style={{ flex: 1, height: 1, background: 'rgba(200,150,42,0.25)' }} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {DEMO.map(acc => (
                <button key={acc.email} onClick={() => demoLogin(acc.email)} disabled={loading}
                  style={{ flex: 1, padding: '8px 6px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(200,150,42,0.25)', borderRadius: 10, cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#C8962A'; e.currentTarget.style.background = 'rgba(200,150,42,0.12)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(200,150,42,0.25)'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: '#D4A520', fontFamily: "'Barlow Condensed', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>{acc.label}</div>
                  <div style={{ fontSize: 10, color: '#888888', marginTop: 1 }}>{acc.role}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
